
import {
  Sparkles, Star, Users, MessageCircle, Mail, MapPin, Phone, Globe,
  Heart, Award, Shield, Clock, CheckCircle, Zap, Target, type LucideIcon,
} from 'lucide-react';
import { useServicesContent } from "@/hooks/useServicesContent";

interface BadgeItem { label: string; icon: string; }

const BADGE_ICON_MAP: Record<string, LucideIcon> = {
  Users, Star, Sparkles, MessageCircle, Mail, MapPin, Phone, Globe,
  Heart, Award, Shield, Clock, CheckCircle, Zap, Target,
};

const DEFAULT_BADGES: BadgeItem[] = [
  { label: '+500 Pacientes', icon: 'Users' },
  { label: '5.0 no Google', icon: 'Star' },
  { label: 'Plano Personalizado', icon: 'Sparkles' },
];

function parseBadges(raw: any[]): BadgeItem[] {
  return raw.map(b => typeof b === 'string' ? { label: b, icon: 'Star' } : b);
}

export function ServicesHero() {
  const { content, loading } = useServicesContent("hero");
  const heroData = content[0]?.content_value as {
    title?: string; subtitle?: string; label?: string; badges?: any[];
  } | undefined;

  const title    = heroData?.title    || "Nossos Serviços";
  const subtitle = heroData?.subtitle || "Soluções personalizadas para cada necessidade, sempre com foco no seu bem-estar";
  const label    = heroData?.label    || "Atendimento Personalizado";
  const badges   = heroData?.badges ? parseBadges(heroData.badges) : DEFAULT_BADGES;

  return (
    <section className="bg-brand-primary py-14 sm:py-20">
      <div className="container mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 text-white/90 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide uppercase">
          <Sparkles className="w-3.5 h-3.5" />
          {label}
        </div>

        {loading ? (
          <>
            <div className="h-12 w-64 bg-white/15 rounded-xl mx-auto mb-4 animate-pulse" />
            <div className="h-6 w-96 bg-white/10 rounded-lg mx-auto" />
          </>
        ) : (
          <>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-primary mb-4 leading-tight">
              {title}
            </h1>
            <p className="text-white/75 text-base sm:text-lg max-w-2xl mx-auto font-primary">
              {subtitle}
            </p>
          </>
        )}

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          {badges.map((badge, i) => {
            const Icon = BADGE_ICON_MAP[badge.icon] || Star;
            return (
              <div key={i} className="flex items-center gap-2 bg-white/10 text-white text-sm font-medium px-4 py-2 rounded-full">
                <Icon className="w-4 h-4 text-white/70" />
                {badge.label}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
